import { render, staticRenderFns } from "./cardInfo.vue?vue&type=template&id=3735f124&"
import script from "./cardInfo.vue?vue&type=script&lang=js&"
export * from "./cardInfo.vue?vue&type=script&lang=js&"
import style0 from "./cardInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports